{
  "eyebrow": "Confirmez votre formule",
  "title": "Vérifiez et configurez.",
  "sub": "Vous pouvez changer de cycle de facturation ou de formule à tout moment depuis votre tableau de bord administrateur.",
  "yourPlan": "Votre formule",
  "changePlan": "Changer de formule",
  "billing": "Cycle de facturation",
  "billingMonthLabel": "Paiement mensuel",
  "billingMonthDesc": "Flexible. Annulez à tout moment.",
  "billingYearLabel": "Paiement annuel",
  "billingYearDesc": "15% de réduction. Facturé une fois par an.",
  "addons": "Options",
  "addon": {
    "ssec": "Sécurité sociale (check-in/out@work)",
    "ssecDesc": "Belgique uniquement — déclaration Dimona automatique.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "GPS en direct pour les véhicules d'entreprise. +€4,80 / véhicule / mois.",
    "vehicles": "Véhicules"
  },
  "users": {
    "title": "De combien d'utilisateurs avez-vous besoin ?",
    "help": "Chaque personne qui utilise Done-it compte pour un utilisateur, y compris les administrateurs et les employés.",
    "active": "utilisateurs"
  },
  "estimate": "Coût mensuel estimé",
  "estimateNote": "Hors TVA. Vous payez pour le nombre d’utilisateurs défini ici et vous pourrez le modifier plus tard.",
  "estimateUnavailable": "Catalogue de prix indisponible. Réessayez pour charger les derniers prix."
}
